import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Alert, AlertDescription } from '../../components/ui/alert';
import { Button } from '../../components/ui/button';
import { Clock, Calendar, AlertTriangle, ShoppingCart } from 'lucide-react';

const statusStyles = {
  active: 'bg-emerald-500/20 text-emerald-400',
  pending: 'bg-yellow-500/20 text-yellow-400',
  consumed: 'bg-red-500/20 text-red-400',
  cancelled: 'bg-gray-500/20 text-gray-400',
  expired: 'bg-gray-500/20 text-gray-400'
};

const statusLabels = {
  active: 'Activa', pending: 'Pendiente (72h)', consumed: 'Consumida', cancelled: 'Cancelada', expired: 'Expirada'
};

export const MembershipStatus = ({ m, daysLeft, isActive, isPending, needsRenewal, handleBuySubscription }) => {
  return (
    <Card className="border border-white/10 bg-[#111] shadow-xl" data-testid="membership-status-card">
      <CardContent className="p-6">
        <div className="flex items-center justify-between mb-5">
          <h3 className="text-white font-semibold text-lg">Estado de Membresia</h3>
          <span className={`px-3 py-1 rounded-full text-xs font-bold ${statusStyles[m?.status] || statusStyles.expired}`} data-testid="membership-status">
            {statusLabels[m?.status] || 'Expirada'}
          </span>
        </div>

        <div className="grid grid-cols-2 gap-4 mb-5">
          <div className="bg-white/5 rounded-xl p-4 border border-white/5">
            <div className="flex items-center gap-2 mb-1">
              <Calendar className="w-3.5 h-3.5 text-gray-500" />
              <p className="text-gray-500 text-xs">Activacion</p>
            </div>
            <p className="text-white font-medium text-sm">
              {m?.activation_date ? new Date(m.activation_date).toLocaleDateString('es-MX', { day: 'numeric', month: 'short', year: 'numeric' }) : 'Pendiente'}
            </p>
          </div>
          <div className="bg-white/5 rounded-xl p-4 border border-white/5">
            <div className="flex items-center gap-2 mb-1">
              <Clock className="w-3.5 h-3.5 text-gray-500" />
              <p className="text-gray-500 text-xs">Expiracion</p>
            </div>
            <p className="text-white font-medium text-sm">
              {m?.expiry_date ? new Date(m.expiry_date).toLocaleDateString('es-MX', { day: 'numeric', month: 'short', year: 'numeric' }) : 'N/A'}
            </p>
          </div>
        </div>

        {isActive && daysLeft !== null && (
          <div className="mb-4">
            <div className="flex justify-between text-xs mb-2">
              <span className="text-gray-400">Dias restantes</span>
              <span className={`font-bold ${daysLeft <= 7 ? 'text-red-400' : daysLeft <= 30 ? 'text-amber-400' : 'text-emerald-400'}`}>
                {daysLeft} dias
              </span>
            </div>
            <div className="w-full bg-white/10 rounded-full h-2 overflow-hidden">
              <div className={`h-full rounded-full transition-all duration-700 ${daysLeft <= 7 ? 'bg-red-500' : daysLeft <= 30 ? 'bg-amber-500' : 'bg-emerald-500'}`}
                style={{ width: `${Math.min(100, (daysLeft / 365) * 100)}%` }} />
            </div>
          </div>
        )}

        {isPending && (
          <Alert className="bg-blue-500/10 border-blue-500/20">
            <Clock className="h-4 w-4 text-blue-400" />
            <AlertDescription className="text-blue-300 text-sm">
              Tu membresia se activara automaticamente 72 horas despues de tu compra.
            </AlertDescription>
          </Alert>
        )}
        {needsRenewal && (
          <Alert className="bg-amber-500/10 border-amber-500/20">
            <AlertTriangle className="h-4 w-4 text-amber-400" />
            <AlertDescription className="text-amber-300 text-sm">
              {m?.status === 'consumed' ? 'Ya utilizaste tu servicio. Renueva para seguir protegido.' : 'Tu membresia ha expirado. Renueva ahora.'}
            </AlertDescription>
          </Alert>
        )}

        {(needsRenewal || (isActive && daysLeft !== null && daysLeft <= 30)) && (
          <div className="mt-4 pt-4 border-t border-white/10">
            <Button onClick={() => handleBuySubscription(false)}
              className="w-full bg-[#C81D25] hover:bg-[#A6141B] text-white py-5 font-bold" data-testid="renew-membership-btn">
              <ShoppingCart className="w-4 h-4 mr-2" />Renovar Membresia — $899 MXN
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
